import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Paragraph } from 'components/core/Typography';
import { ReviewRating } from 'components/reviewV2/Review';
import googleLogo from 'assets/images/logos/google-logo.svg';
import fallbackAvatar from 'assets/images/confirmation/stuff.svg';
import './googleReviewCard.scss';

export function GoogleReviewCard({
	className,
	reviewerName,
	reviewerPhoto,
	rating,
	reviewDate,
	reviewText,
}) {
	return (
		<li className={classnames(className, 'google-review-card-list')}>
			<div className="google-review-card">
				<div className="review-header">
					<div className="reviewer-info">
						<div className="avatar-wrapper">
							<img
								src={reviewerPhoto || fallbackAvatar}
								alt={`${reviewerName}'s profile`}
								className="avatar reviewer-photo"
								onError={(e) => {
									e.currentTarget.src = fallbackAvatar;
								}}
							/>
						</div>
						<div className="reviewer-name-wrap">
							<Paragraph
								bold
								className="name reviewer-name"
							>
								{reviewerName}
							</Paragraph>
						</div>
					</div>
					<div className="google-logo">
						<img
							src={googleLogo}
							alt="Google logo"
						/>
					</div>
				</div>
				<div className="reviewer-meta-row">
					<ReviewRating
						reviewDate={reviewDate}
						reviewRating={rating}
						reviewRatingOutOf={5}
						size={'small'}
					/>
				</div>

				<div className="review-body">
					<Paragraph>{reviewText}</Paragraph>
				</div>
			</div>
		</li>
	);
}

GoogleReviewCard.propTypes = {
	className: PropTypes.string,
	reviewerName: PropTypes.string.isRequired,
	reviewerPhoto: PropTypes.string,
	rating: PropTypes.number.isRequired,
	reviewDate: PropTypes.string,
	reviewText: PropTypes.string,
};

export default GoogleReviewCard;
